import { Component } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import { TwitchEmbed, TwitchEmbedLayout } from 'twitch-player';

@Component({})
export default class TwitchStreamContainer extends EditorBase {
  mounted() {
    if (this.isMobile) return;

    new TwitchEmbed('twitch-embed', {
      width: '100%',
      height: '100%',
      channel: this.channelName,
      layout: TwitchEmbedLayout.VIDEO_WITH_CHAT,
      muted: true,
    });

  }

  get channelName(): string {
    return this.userTwitchAccount.name;
  }

  get origin(): string {
    return window.location.hostname;
  }
}
